import { apiAxios } from '../../../helpers'

export const getList = async commit => {
  commit('updateLoading', true)
  const result = await apiAxios
    .post('stadiums/')
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data.stadiums)
}

export const getOne = async (commit, id) => {
  if (!id) return
  commit('updateLoading', true)

  const result = await apiAxios
    .get('stadiums/' + id)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data.stadium)
}
